import turboMount, { registerComponent } from '@/global/turbo-mount';
import { setupContinueWithEmail } from '@/utils/loginAndSignupForms';
import { setupLastLoginMethod } from '@/utils/lastLoginMethod';
import getSignUpTrackers from '@/utils/getSignupTrackers';
import LoginCard from '@/components/auth/LoginCard';
import { initDevLoginPanel } from '@/components/login/devPanel';

registerComponent(turboMount, 'LoginCard', LoginCard);

document.addEventListener('DOMContentLoaded', () => {
  // These bind to the server-rendered legacy form. On the redesign the form is
  // React-rendered (LoginCard), so the controller is absent here and the dev
  // login panel is handled there by the React dev kit, not this legacy
  // helper.
  if (!document.querySelector('[data-controller="turbo-mount-login-card"]')) {
    setupContinueWithEmail('new_session');
    setupLastLoginMethod();
    initDevLoginPanel();
  }

  getSignUpTrackers();
});
